<template>
  <div>
    <homePage></homePage>
    <homePage1></homePage1>
    <homePage2></homePage2>
    <homePage3></homePage3>
    <homePage4></homePage4>
    <homePage5></homePage5>
    <homePage6></homePage6>
    <footerBox></footerBox>
  </div>
</template>

<script>
import homePage from "./homePage.vue"
import homePage1 from "./homePage1.vue"
import homePage2 from "./homePage2.vue"
import homePage3 from "./homePage3.vue"
import homePage4 from "./homePage4.vue"
import homePage5 from "./homePage5.vue"
import homePage6 from "./homePage6.vue"
import footerBox from "../../components/footerBox.vue"
export default {
  components: {
    homePage,
    homePage1,
    homePage2,
    homePage3,
    homePage4,
    homePage5,
    homePage6,
    footerBox,
  },
  data() {
    return {}
  },
}
</script>

<style scoped></style>
